"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("./utils.js");

var _defaultFSFunction = _interopRequireDefault(require("./defaultFSFunction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FSWrapper =
/*#__PURE__*/
function () {
  function FSWrapper(params) {
    _classCallCheck(this, FSWrapper);

    var validParams = ['host', 'org', 'namespace', 'debug', 'allowLocalhost'];
    Object.keys(params).forEach(function (p) {
      if (!validParams.includes(p)) {
        console.error("Invalid param ".concat(p, " passed to FSWrapper"));
      }
    });
    var host = params.host,
        org = params.org,
        namespace = params.namespace,
        debug = params.debug,
        allowLocalhost = params.allowLocalhost;
    this.host = host || 'fullstory.com';
    this.org = org;
    this.namespace = namespace || 'FS';
    this.debug = debug || false;
    this.allowLocalhost = allowLocalhost || false;
  }

  _createClass(FSWrapper, [{
    key: "_initFs",
    value: function _initFs() {
      window._fs_host = this.host;
      window._fs_org = this.org;
      window._fs_debug = this.debug;
      (0, _defaultFSFunction["default"])(window, document, this.namespace, 'script', 'user');
    }
  }, {
    key: "_warn",
    value: function _warn(msg) {
      if (this.debug) {
        console.warn(msg);
      }
    }
  }, {
    key: "_isActiveOrg",
    value: function _isActiveOrg() {
      var activeOrg = FSWrapper.getActiveOrg();

      if (activeOrg && activeOrg !== this.org) {
        this._warn("FullStory is already recording for a different organization ".concat(activeOrg, ". The sessions for org ").concat(this.org, " will not be recorded."));

        return false;
      }

      return true;
    }
    /**
     * @param {Object} profile {
     *    @property {string} user_id
     *    @property {string} email
     * }
    */

  }, {
    key: "tryIdentifySession",
    value: function () {
      var _tryIdentifySession = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(profile, reportingUsersBlacklist) {
        var sProfile, activeOrg;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sProfile = profile || {};

                if (!sProfile.user_id) {
                  this._warn('Profile or user id are missing.');
                }

                if (!(reportingUsersBlacklist && reportingUsersBlacklist.includes(sProfile.user_id))) {
                  _context.next = 5;
                  break;
                }

                this._warn('This session will be ignored by FullStory because the current user is blacklisted.');

                return _context.abrupt("return", false);

              case 5:
                if (!(!this.allowLocalhost && (0, _utils.isLocalhost)())) {
                  _context.next = 8;
                  break;
                }

                this._warn('This session will be ignored by FullStory because it is a local session.');

                return _context.abrupt("return", false);

              case 8:
                if (this._isActiveOrg()) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                activeOrg = FSWrapper.getActiveOrg();

                if (!activeOrg) {
                  this._initFs();
                }

                return _context.abrupt("return", this._setIdentity(sProfile));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function tryIdentifySession(_x, _x2) {
        return _tryIdentifySession.apply(this, arguments);
      }

      return tryIdentifySession;
    }()
  }, {
    key: "splitSession",
    value: function splitSession() {
      if (!this._isActiveOrg) {
        return false;
      }

      var activeOrg = FSWrapper.getActiveOrg();

      if (!activeOrg) {
        return false;
      }

      if (window[this.namespace].identify) {
        window[this.namespace].identify(false);
      } else {
        window._fs_ready = null;
      }

      return true;
    }
  }, {
    key: "_setIdentity",
    value: function () {
      var _setIdentity2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(profile) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this._isActiveOrg()) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:
                if (!window[this.namespace].identify) {
                  _context2.next = 7;
                  break;
                }

                window[this.namespace].identify(profile.user_id, {
                  displayName: profile.name,
                  email: profile.email
                });
                return _context2.abrupt("return", true);

              case 7:
                return _context2.abrupt("return", new Promise(function (resolve) {
                  window._fs_ready = function () {
                    if (!_this._isActiveOrg()) {
                      resolve(false);
                      return;
                    }

                    window[_this.namespace].identify(profile.user_id, {
                      displayName: profile.name,
                      email: profile.email
                    });

                    resolve(true);
                  };
                }));

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _setIdentity(_x3) {
        return _setIdentity2.apply(this, arguments);
      }

      return _setIdentity;
    }()
  }]);

  return FSWrapper;
}();

FSWrapper.getActiveOrg = function () {
  return window._fs_org;
};

var _default = FSWrapper;
exports["default"] = _default;